module.exports = __webpack_public_path__ + "static/img/alarm.77a2668a.png";